import { atom, useAtomValue, useSetAtom } from 'jotai';

/** 本地搜索下拉框显示隐藏控制 */
export const searchMsgListStatus = atom<boolean>(false);

export const useSearchMsgListStatus = () => {
  return useAtomValue(searchMsgListStatus);
};

export const useSetSearchMsgListStatus = () => {
  return useSetAtom(searchMsgListStatus);
};
